export default __webpack_public_path__ + "static/media/Background_00284.6e6fd6e4.png";